module.exports = __webpack_public_path__ + "img/banner-lg.1dd0c2d3.jpg";